import {
    FormControl,
    FormHelperText,
    InputLabel,
    MenuItem,
    Select,
    SelectChangeEvent,
} from '@mui/material'
import { createTheme, ThemeProvider } from '@mui/material/styles'

const theme = createTheme({
    palette: {
        primary: {
            main: '#434a73',
        },
    },
})

type Props = {
    label: string
    data?: Array<string>
    value: string | Array<string>
    onChange?: (value: SelectChangeEvent<string | Array<string>>) => void
    name?: string
    className?: string
    multiple?: boolean
    disabled?: boolean
    errorText?: string
    fullHeight?: boolean
}
const CustomDropdown = ({
    label,
    errorText,
    data,
    className,
    fullHeight = false,
    ...restOfProps
}: Props) => {
    return (
        <FormControl>
            <ThemeProvider theme={theme}>
                <InputLabel id="demo-simple-select-label">{label}</InputLabel>
                <Select
                    MenuProps={{
                        autoFocus: false,
                        sx: {
                            overflowY: 'scroll',
                            overflowX: 'scroll',
                        },
                        PaperProps: {
                            sx: {
                                maxHeight: fullHeight ? undefined : '208px',
                            },
                        },
                    }}
                    error={!!errorText}
                    className={`${className}`}
                    color="primary"
                    id="demo-simple-select"
                    label={label}
                    labelId="demo-simple-select-label"
                    {...restOfProps}
                >
                    {data?.map((valueData) => (
                        <MenuItem
                            key={valueData}
                            className="w-full"
                            value={valueData}
                        >
                            {valueData}
                        </MenuItem>
                    ))}
                </Select>
                <FormHelperText>{errorText}</FormHelperText>
            </ThemeProvider>
        </FormControl>
    )
}

export default CustomDropdown
